import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProviderOrder } from 'src/app/calvin-emr-shared/models/provider-order.model';
import { DividerModule } from 'primeng/divider';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'app-order-view-dialog',
  templateUrl: './order-view-dialog.component.html',
  styleUrls: ['./order-view-dialog.component.scss'],
  standalone: true,
  imports: [
    DividerModule,
    ButtonDirective,
  ],
})
export class OrderViewDialogComponent implements OnInit {
  order: ProviderOrder;

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    this.order = config.data as ProviderOrder;
  }

  ngOnInit(): void { }

  closeDialog() {
    this.ref.close();
  }
}
